import { withStyles } from '@material-ui/core/styles';
import Modal from './Modal';
import styles from './Modal.styles';

export default withStyles(styles)(Modal);
